<div class="splash">
  <div class="splash--container">
    <div class="" style="transform: translateX(-60px)">
      We
      <div class="words">
        <span>help</span>
        <span>change</span>
        <span>digitize</span>
        <span>help</span>
        <span>change</span>
        <span>digitize</span>
        <span>help</span>
        <span>change</span>
        <span>digitize</span>
        <span>help</span>
        <span>change</span>
        <span>digitize</span>
        <span>help</span>
        <span>change</span>
        <span>digitize</span>
        <span>help</span>
        <span>change</span>
        <span>digitize</span>
      </div>
    </div>
  </div>
</div>
